module.exports = __webpack_public_path__ + "static/img/unxp-header.b55c2236.png";